import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Settings } from '../../core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SponsorStudy } from '../../sponsor-dashboard/sponsor-study';


@Injectable()
export class TableauStorage {
    constructor(
        private settings: Settings,
        private http: HttpClient,
    ) { }

    public getTrustedToken(study: SponsorStudy): Observable<any> {
      return this.http.get(`${this.settings.apiUrl}/sponsor/tableau/study/${study.protocolId}/login`, {responseType: 'text'});
    }

    public getAllDashboards(study: SponsorStudy): Observable<any> {
        return this.http.get(`${this.settings.apiUrl}/sponsor/tableau/study/${study.protocolId}/dashboards`)
            .pipe(map( r => r));
    }
}

